import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const articles = [
  {
    title: '2025 California Rental Law Changes',
    description: 'Everything landlords need to know about AB 12, SB 644, and other new regulations...',
    gradient: 'linear-gradient(135deg, #0066FF 0%, #0052CC 100%)',
  },
  {
    title: 'Security Deposit Cap Guide',
    description: 'How the new 1-month deposit limit affects your rentals and what you can do...',
    gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
  },
  {
    title: 'Eviction Process in California',
    description: 'Step-by-step guide to legal eviction procedures and common pitfalls to avoid...',
    gradient: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)',
  },
];

const BlogSection: React.FC = () => {
  return (
    <SectionBackground className="features" style={{ padding: '80px 16px' }}>
      <div className="container">
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: 20, fontWeight: 700 }}>
          California Landlord Resources
        </h2>
        <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: '1.2rem', marginBottom: 60 }}>
          Stay informed about California rental laws and best practices
        </p>
        <div className="features-grid">
          {articles.map((article, idx) => (
            <div 
              className="feature-card" 
              key={idx}
              style={{
                background: 'var(--bg-light)',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease',
                padding: 0,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{
                height: 200,
                background: article.gradient,
              }} />
              <div style={{ padding: '30px' }}>
                <h3 style={{ fontSize: '1.5rem', marginBottom: '15px', fontWeight: 600 }}>
                  {article.title}
                </h3>
                <p style={{ color: 'var(--text-light)', lineHeight: 1.8, marginBottom: '20px' }}>
                  {article.description}
                </p>
                <button
                  style={{
                    color: 'var(--primary)',
                    fontWeight: 600,
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    font: 'inherit',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.textDecoration = 'underline';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.textDecoration = 'none';
                  }}
                >
                  Read More →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionBackground>
  );
};

export default BlogSection; 